import { graphql } from 'gatsby';
import React from 'react';
import Seo from '../../components/SEO';
import ArticleLanding from '../../components/ArticleLanding/ArticleLanding';
import ArticleNav from '../../components/ArticleNav/ArticleNav';
import HeaderTheme from '../../components/Header/HeaderTheme';

const CategoryTemplate = ({
  data: {
    page: { name, description, posts },
    wp: {
      seo,
      readingSettings: { postsPerPage },
    },
  },
}) => {
  return (
    <>
      <HeaderTheme />
      <Seo
          title={`${name} | The Prime Health Journal`}
          description={description}
          postSchema={JSON.parse(
            seo.contentTypes.post.schema.raw
          )}
      />
      <ArticleNav />
      <ArticleLanding {...posts} perPage={postsPerPage} />
    </>
  );
};

export default CategoryTemplate;

export const query = graphql`
  query BlogCategoryTemplate($id: String!) {
    wp {
      readingSettings {
        postsPerPage
      }
      seo {
        contentTypes {
          post {
            schema {
              raw
            }
          }
        }
      }
    }
    page: wpCategory(id: { eq: $id }) {
      name
      description
      posts {
        nodes {
          ...Post
        }
      }
    }
  }
`;
